import { ValidationErrors } from "src/errors";
import { ResolveIssueFormData, ResolveIssueFormDataKey } from "src/types";
import { useScrollOnMessage } from "src/hooks";
import { TextInputBoxLarge } from "src/components/ui/inputs";
import { FormLvlErrorMessage, ValidationErrorMessage } from "src/components/ui/feedback";

interface ResolveIssueFormProps {
  formData: ResolveIssueFormData;
  validationErrors?: ValidationErrors<ResolveIssueFormDataKey>;
  formLvlErrorMessage: string;
  isFormComplete: boolean;
  handleInputChange: (
    field: ResolveIssueFormDataKey,
    value: ResolveIssueFormDataKey[keyof ResolveIssueFormDataKey]
  ) => void;
  handleSubmit: (e?: React.FormEvent) => void;
}

const ResolveIssueForm: React.FC<ResolveIssueFormProps> = ({
  formData,
  validationErrors,
  formLvlErrorMessage,
  isFormComplete,
  handleInputChange,
  handleSubmit
}) => {
  const formLvlErrorMessageRef = useScrollOnMessage(formLvlErrorMessage);

  return (
    <form onSubmit={handleSubmit} autoComplete="off" className="space-y-6">
      <div className="space-y-3">
        <div className="flex items-center justify-between">
          <label
            htmlFor="resolution-details"
            className="text-sm font-semibold text-secondary-800 uppercase tracking-wide"
          >
            Resolution Details
          </label>
          <span className="text-xs text-secondary-500">
            {(formData.resolutionDetails?.length ?? 0).toString().padStart(3, "0")}/500
          </span>
        </div>

        <TextInputBoxLarge
          id="resolution-details"
          placeholder="Describe how this issue was resolved..."
          value={formData.resolutionDetails}
          onChange={(value) => handleInputChange("resolutionDetails", value)}
          rows={5}
          maxLength={500}
        />

        <ValidationErrorMessage message={validationErrors?.getErrorMessageByFormDataKey("resolutionDetails")} />
      </div>

      <FormLvlErrorMessage message={formLvlErrorMessage} centred={false} ref={formLvlErrorMessageRef} />

      <div className="flex flex-wrap items-center gap-4">
        <button
          className="inline-flex items-center justify-center rounded-lg bg-black px-6 py-3 text-sm font-semibold text-white transition-colors duration-200 hover:bg-gray-900 disabled:cursor-not-allowed disabled:bg-gray-300"
          disabled={!isFormComplete}
          type="submit"
        >
          Resolve Issue
        </button>
        <p className="text-xs text-secondary-500">A confirmation modal will appear before final submission.</p>
      </div>
    </form>
  );
};

export { ResolveIssueForm };
